/// <amd-module name="Widgets/TeamMembersWidget/components/TeamMembersWidgetDataProvider" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IdentityImageSize, IVssIdentityService } from "VSS/Platform/Identity";
import { ExtendedError } from "WidgetCommon/CommonUtils/ExtendedError";

export interface TeamMemberData {
    count: { value: number };
    members: IdentityRef[];
}

export class TeamMembersWidgetDataProvider {
    private static readonly dataProviderContributionId = "ms.vss-dashboards-web.team-members-widget-data-provider";

    public constructor(private pageContext: IVssPageContext) {}

    public async getTeamMembers(teamId: string, ignoreCache?: boolean): Promise<TeamMemberData> {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const teamMemberData = await contributionService.getDataAsync<TeamMemberData>(
            TeamMembersWidgetDataProvider.dataProviderContributionId,
            {
                teamId: teamId
            },
            ignoreCache
        );
        if (!teamMemberData) {
            const ex = contributionService.getDataProviderExceptions()[TeamMembersWidgetDataProvider.dataProviderContributionId];
            const message = ["Couldn't fetch team member information.", ex && ex.message].join(" ");
            throw new ExtendedError(message, ex);
        }
        const identityService = this.pageContext.getService<IVssIdentityService>("IVssIdentityService");
        for (const member of teamMemberData.members) {
            member.imageUrl = identityService.getIdentityImageUrl(member.id, IdentityImageSize.small);
        }
        return teamMemberData;
    }
}
